import { Page } from '@/types/pages.types';
import { ReportFlowStep } from '@/types/report.types';

export const buildTokenizedUrl = (token: string, page: Page, query?: string) =>
  `/${token}/${page}${query ? `?${query}` : ''}`;

export const getDefaultRedirectPath = (token: string) =>
  buildTokenizedUrl(token, Page.Report, `step=${ReportFlowStep.Distress}`);
